import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { Estate } from './estate';

type UnpublishEstateOptions = {
  mutationConfig?: MutationConfig<typeof unpublishEstate>;
};

const unpublishEstate = (id: Estate['id']) => {
  return extractData(api.estates({ id }).unpublish.put());
};

export const useUnpublishEstate = ({ mutationConfig }: UnpublishEstateOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: unpublishEstate,
  });
};
